module.exports = __webpack_public_path__ + "img/person-from-portal.9e61a49c.svg";